// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 4.5C1.5 3.4 2.4 2.5 3.5 2.5H12.5C13.6 2.5 14.5 3.4 14.5 4.5V9.5C14.5 10.6 13.6 11.5 12.5 11.5H3.5C2.4 11.5 1.5 10.6 1.5 9.5V4.5Z',
  'M8 11.5V14',
  'M5.5 14H10.5',
];
